import { Col, Row, Button } from 'antd';
import React, { useEffect, useState } from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TUser from './Tables/TUser';
import { UserState } from '../../store/user/types';
import { connect } from 'react-redux';
import { AppState } from '../../store';
import TGeiInventory from './Tables/TGeiInventory';
import styles from 'src/components/Admin/Result/Results.module.scss';
import { useHistory } from 'react-router-dom';
import TGeiEvent from './Tables/GeiEvents/TGeiEvent';
import { getStyleCookie } from 'src/services/auth'; // Asegúrate de que esta es tu función síncrona

interface GeiInventoryProps {
    user: UserState;
}

const GeiEvent: React.FC<GeiInventoryProps> = (props: GeiInventoryProps) => {
    const history = useHistory();
    const [styleOrganization, setStyleOrganization] = useState(getStyleCookie() || "");

    return (
        <div>
           <div>
                <br />
                <div className={styles["admin-header"]}>
                    <div ><span className={styles["header"]}> Información eventos GEI</span>
                    </div>
                </div>
                <br />
            </div>
            <div className={styleOrganization}>
                <TGeiEvent/>
            </div>
        </div>
    );
};

const mapStateToProps = (state: AppState) => ({
    user: state.user
});

export default connect(mapStateToProps, {})(GeiEvent);